import { Align } from "../../../../common/TextUtils"
import { PhaserText } from "../../../utils/PhaserText"

export class ScoreText {
    scoreText: Phaser.Text
    private SCORE = 0

    constructor(game: Phaser.Game, x: number, y: number) {
        this.scoreText = PhaserText.create(game, "0", {
            x,
            y,
            fontPx: 32,
            weight: "bold",
            align: Align.RIGHT
        })
    }

    get score(): number {
        return this.SCORE
    }

    set score(newScore: number) {
        this.SCORE = newScore
        this.scoreText.setText(`${this.score}`)
    }

    calculateScore = (points: number) => this.score += points

    reset = () => this.score = 0

}